import { products } from "./Products";

export const prompt1T = (answer) => {
  if (answer === "optionA") {
    return products[0].productName;
  }

  if (answer === "optionB") {
    return products[1].productName;
  }

  if (answer === "optionC") {
    return products[2].productName;
  }
};

export const prompt1M = (answer) => {
  if (answer === "optionA") {
    return products[0].productMedia;
  }

  if (answer === "optionB") {
    return products[1].productMedia;
  }

  if (answer === "optionC") {
    return products[2].productMedia;
  }
};

export const prompt1D = (answer) => {
  if (answer === "optionA") {
    return products[0].productDescription;
  }

  if (answer === "optionB") {
    return products[1].productDescription;
  }

  if (answer === "optionC") {
    return products[2].productDescription;
  }
};
export const prompt1L = (answer) => {
  if (answer === "optionA") {
    return products[0].productLink;
  }

  if (answer === "optionB") {
    return products[1].productLink;
  }

  if (answer === "optionC") {
    return products[2].productLink;
  }
};

export const prompt2T = (answer) => {
  if (answer === "optionA") {
    return products[3].productName;
  }
  if (answer === "optionB") {
    return products[4].productName;
  }
  if (answer === "optionC") {
    return products[5].productName;
  }
};

export const prompt2M = (answer) => {
  if (answer === "optionA") {
    return products[3].productMedia;
  }
  if (answer === "optionB") {
    return products[4].productMedia;
  }
  if (answer === "optionC") {
    return products[5].productMedia;
  }
};

export const prompt2D = (answer) => {
  if (answer === "optionA") {
    return products[3].productDescription;
  }
  if (answer === "optionB") {
    return products[4].productDescription;
  }
  if (answer === "optionC") {
    return products[5].productDescription;
  }
};
export const prompt2L = (answer) => {
  if (answer === "optionA") {
    return products[3].productLink;
  }
  if (answer === "optionB") {
    return products[4].productLink;
  }
  if (answer === "optionC") {
    return products[5].productLink;
  }
};

export const prompt3T = (answer) => {
  if (answer === "optionA") {
    return products[6].productName;
  }
  if (answer === "optionB") {
    return products[7].productName;
  }
  if (answer === "optionC") {
    return products[8].productName;
  }
};

export const prompt3M = (answer) => {
  if (answer === "optionA") {
    return products[6].productMedia;
  }
  if (answer === "optionB") {
    return products[7].productMedia;
  }
  if (answer === "optionC") {
    return products[8].productMedia;
  }
};

export const prompt3D = (answer) => {
  if (answer === "optionA") {
    return products[6].productDescription;
  }
  if (answer === "optionB") {
    return products[7].productDescription;
  }
  if (answer === "optionC") {
    return products[8].productDescription;
  }
};
export const prompt3L = (answer) => {
  if (answer === "optionA") {
    return products[6].productLink;
  }
  if (answer === "optionB") {
    return products[7].productLink;
  }
  if (answer === "optionC") {
    return products[8].productLink;
  }
};

export const prompt4T = (answer) => {
  if (answer === "optionA") {
    return products[9].productName;
  }
  if (answer === "optionB") {
    return products[10].productName;
  }
  if (answer === "optionC") {
    return products[11].productName;
  }
  if (answer === "optionD") {
    return products[12].productName;
  }
};

export const prompt4M = (answer) => {
  if (answer === "optionA") {
    return products[9].productMedia;
  }
  if (answer === "optionB") {
    return products[10].productMedia;
  }
  if (answer === "optionC") {
    return products[11].productMedia;
  }
  if (answer === "optionD") {
    return products[12].productMedia;
  }
};

export const prompt4D = (answer) => {
  if (answer === "optionA") {
    return products[9].productDescription;
  }
  if (answer === "optionB") {
    return products[10].productDescription;
  }
  if (answer === "optionC") {
    return products[11].productDescription;
  }
  if (answer === "optionD") {
    return products[12].productDescription;
  }
};
export const prompt4L = (answer) => {
  if (answer === "optionA") {
    return products[9].productLink;
  }
  if (answer === "optionB") {
    return products[10].productLink;
  }
  if (answer === "optionC") {
    return products[11].productLink;
  }
  if (answer === "optionD") {
    return products[12].productLink;
  }
};

export const prompt5T = (answer) => {
  if (answer === "optionA") {
    return products[13].productName;
  }
  if (answer === "optionB") {
    return products[14].productName;
  }
  if (answer === "optionC") {
    return products[15].productName;
  }
};

export const prompt5M = (answer) => {
  if (answer === "optionA") {
    return products[13].productMedia;
  }
  if (answer === "optionB") {
    return products[14].productMedia;
  }
  if (answer === "optionC") {
    return products[15].productMedia;
  }
};

export const prompt5D = (answer) => {
  if (answer === "optionA") {
    return products[13].productDescription;
  }
  if (answer === "optionB") {
    return products[14].productDescription;
  }
  if (answer === "optionC") {
    return products[15].productDescription;
  }
};

export const prompt5L = (answer) => {
  if (answer === "optionA") {
    return products[13].productLink;
  }
  if (answer === "optionB") {
    return products[14].productLink;
  }
  if (answer === "optionC") {
    return products[15].productLink;
  }
};
